import React from 'react';
import './GovernmentLogoMarquee.css';

export const GOVERNMENT_LINKS = Object.freeze([
  { name: 'MahaDBT', detail: 'महाराष्ट्र थेट लाभ हस्तांतरण', href: 'https://mahadbt.maharashtra.gov.in', domain: 'mahadbt.maharashtra.gov.in', logo: '/government-logos/mahadbt.svg' },
  { name: 'India.gov.in', detail: 'भारताचे राष्ट्रीय पोर्टल', href: 'https://india.gov.in', domain: 'india.gov.in', logo: '/government-logos/india-gov.svg' },
  { name: 'MyGov India', detail: 'नागरिक सहभाग मंच', href: 'https://www.mygov.in', domain: 'mygov.in', logo: '/government-logos/mygov.svg' },
  { name: 'Digital India', detail: 'डिजिटल भारत कार्यक्रम', href: 'https://digitalindia.gov.in', domain: 'digitalindia.gov.in', logo: '/government-logos/digital-india.svg' },
  { name: 'UMANG', detail: 'शासकीय सेवा एकाच ठिकाणी', href: 'https://web.umang.gov.in', domain: 'web.umang.gov.in', logo: '/government-logos/umang.png' },
  { name: 'Aadhaar UIDAI', detail: 'भारतीय विशिष्ट ओळख प्राधिकरण', href: 'https://uidai.gov.in', domain: 'uidai.gov.in', logo: '/government-logos/uidai.svg' },
  { name: 'Swachh Bharat', detail: 'स्वच्छ भारत अभियान', href: 'https://swachhbharatmission.ddws.gov.in', domain: 'swachhbharatmission.ddws.gov.in', logo: '/government-logos/swachh-bharat.png' },
  { name: 'राष्ट्रीय सेवा योजना', detail: 'National Service Scheme', href: 'https://nss.gov.in', domain: 'nss.gov.in', logo: '/government-logos/nss.svg' },
  { name: 'आपले सरकार', detail: 'महाराष्ट्र ऑनलाइन सेवा', href: 'https://aaplesarkar.mahaonline.gov.in', domain: 'aaplesarkar.mahaonline.gov.in', logo: '/government-logos/aaple-sarkar.png' },
  { name: 'DigiLocker', detail: 'सुरक्षित डिजिटल दस्तऐवज', href: 'https://www.digilocker.gov.in', domain: 'digilocker.gov.in', logo: '/government-logos/digilocker.webp' },
]);

function LogoGroup({ duplicate = false }) {
  return <div className="government-logo-group" aria-hidden={duplicate || undefined}>
    {GOVERNMENT_LINKS.map(link => (
      <a
        key={`${duplicate ? 'copy-' : ''}${link.domain}`}
        className="government-logo-card"
        href={link.href}
        target="_blank"
        rel="noopener noreferrer"
        tabIndex={duplicate ? -1 : undefined}
        aria-label={`${link.name} संकेतस्थळ उघडा`}
      >
        <span className="government-logo-image"><img src={link.logo} alt="" loading="lazy" /></span>
        <span className="government-logo-copy"><strong>{link.name}</strong><small>{link.detail}</small></span>
        <span className="government-logo-arrow" aria-hidden="true">↗</span>
      </a>
    ))}
  </div>;
}

export default function GovernmentLogoMarquee() {
  return <section className="government-logo-marquee" aria-labelledby="government-sites-heading">
    <div className="government-logo-heading public-container">
      <div><span>उपयुक्त संकेतस्थळे</span><h2 id="government-sites-heading">महत्त्वाच्या शासकीय सेवा</h2></div>
      <p>लोगोवर क्लिक करून संबंधित अधिकृत संकेतस्थळ उघडा</p>
    </div>
    <div className="government-logo-viewport">
      <div className="government-logo-track">
        <LogoGroup />
        <LogoGroup duplicate />
      </div>
    </div>
  </section>;
}
